import React from 'react';
import type { SalesOrderStatus } from '@lognai/plugin-orders';
import { Badge } from '@lognai/synapse-design-system-v2';
import type { BadgeProps } from '@lognai/synapse-design-system-v2';
import { formatSalesOrderStatus } from '../../utils/format';

interface SalesOrderStatusBadgeProps {
  status: SalesOrderStatus;
}

type Tone = NonNullable<BadgeProps['tone']>;

const statusTone: Record<SalesOrderStatus, Tone> = {
  draft:               'neutral',
  cancelled:           'neutral',
  pending:             'warning',
  confirmed:           'info',
  processing:          'info',
  partially_fulfilled: 'warning',
  fulfilled:           'success',
  shipped:             'success',
  delivered:           'success',
};

export const SalesOrderStatusBadge: React.FC<SalesOrderStatusBadgeProps> = ({ status }) => {
  return (
    <Badge tone={statusTone[status]}>
      {formatSalesOrderStatus(status)}
    </Badge>
  );
};
